import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import {
  organizationConfigs,
  mailScopes,
  teamsScopes,
  grAPIScopes,
} from './shared/organization/organization.config';

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();

  const organization = organizationConfigs.find(organization =>
    organization.urls.includes(window.location.origin)
  );

  if (organization?.loginType === 'azure') {
    switch (organization.shortName) {
      case 'gr':
      case 'kst':
        protectedResourceMap.set(
          'https://graph.microsoft.com/v1.0/me/mailFolders/*',
          mailScopes
        );

        protectedResourceMap.set(
          'https://graph.microsoft.com/v1.0/me/messages/*',
          mailScopes
        );

        protectedResourceMap.set(
          'https://graph.microsoft.com/v1.0/me/joinedTeams',
          teamsScopes
        );

        protectedResourceMap.set(
          'https://graph.microsoft.com/v1.0/teams/*',
          teamsScopes
        );

        protectedResourceMap.set(environment.grApiUrl, grAPIScopes);
        break;
    }
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
